export const selectRouter = (state: IState) => state.router
export const selectLocation = (state: IState) => selectRouter(state).location
